import { render } from "./PantryCameraCheckMainView.vue?vue&type=template&id=3df0214c&ts=true"
import script from "./PantryCameraCheckMainView.vue?vue&type=script&lang=ts"
export * from "./PantryCameraCheckMainView.vue?vue&type=script&lang=ts"

import "./PantryCameraCheckMainView.vue?vue&type=style&index=0&id=3df0214c&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__